'use client';

import { Text } from '@smartproxy/decoro/v2/text';

import Heading from '@/components/atoms/Heading';
import { Modal } from '@/components/atoms/Modal';
import {
  PromoBadge,
  type PromoBadgeStrapi,
} from '@/components/atoms/PromoBadge';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/RichTextField/RichTextFieldStrapi';

import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

export type WelcomePopUpProps = {
  image?: React.ReactNode;
  title: string;
  description: RichTextFieldStrapiProps;
  hiddenMobileText?: string;
  buttons?: React.ReactNode;
  promoBadge?: PromoBadgeStrapi | null;
  onClose: () => void;
};

export const WelcomePopUp = ({
  image,
  title,
  description,
  hiddenMobileText,
  buttons,
  promoBadge,
  onClose,
}: WelcomePopUpProps) => {
  return (
    <Modal
      data-tracker-section={SECTION_NAMES.WELCOME_POP_UP}
      isOpen={true}
      closeOnOutsideClick={false}
      onClose={onClose}
      backgroundClickable
      overlayProps={{
        style: {
          display: 'none',
        },
      }}
      classNames={{
        modal:
          'py-10 px-5 md:py-8 w-full md:w-fit lg:block bg-gray-950 border border-gray-600 rounded-xl',
        closeCross: 'w-6 h-6',
        close: 'p-0 right-4 top-4',
        root: 'fixed left-0 bottom-0 top-auto z-50 flex items-end justify-start',
        overlay: 'backdrop-blur-none',
      }}
      lockScroll={false}
    >
      <div className='flex flex-col items-center gap-y-6'>
        <Heading level='h3' classNames={{ root: 'font-serif text-white' }}>
          {title}
          <PromoBadge badge={promoBadge} classNames={{ root: 'ml-3' }} />
        </Heading>
        {image}
        <div className='flex flex-col items-center gap-y-4 text-white'>
          {hiddenMobileText && (
            <Text variant='body_l' color='white' className='md:hidden'>
              {hiddenMobileText}
            </Text>
          )}
          <RichTextFieldStrapi
            block={description}
            classNames={{
              paragraph: 'text-white',
              heading: { h4: { root: 'md:text-h4 text-center text-white' } },
            }}
          />
        </div>
      </div>
      {buttons}
    </Modal>
  );
};
